import { render, staticRenderFns } from "./Item3Space.vue?vue&type=template&id=fdcbc410&"
import script from "./Item3Space.vue?vue&type=script&lang=js&"
export * from "./Item3Space.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports